'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theirs.
var Link = function Link(_ref) {
  var children = _ref.children,
      env = _ref.env,
      href = _ref.href,
      onClick = _ref.onClick,
      target = _ref.target;

  (0, _warning2.default)(!(href && onClick), 'You passed Link both an onClick function and a href string.\n    Functionality is undefined when you do this.');
  var classNames = (0, _classnames2.default)(_styles2.default.link, _styles2.default['link--' + env]);
  var rel = target ? 'noopener noreferrer' : null;
  return _react2.default.createElement(
    'a',
    {
      className: classNames,
      href: href,
      onClick: onClick,
      target: target,
      rel: rel,
      title: children,
      'data-hudl-element': children
    },
    children
  );
};

// Ours.


Link.propTypes = {
  children: _react.PropTypes.string.isRequired,
  env: _react.PropTypes.string,
  href: _react.PropTypes.string,
  onClick: _react.PropTypes.func,
  target: _react.PropTypes.string
};

Link.defaultProps = {
  env: 'light'
};

exports.default = Link;